import { isDivider, isItem } from "./useCollection";
import { getRawSlots, isNil } from "../../shared";
export function getItemText(item) {
  if (isDivider(item) || isItem(item)) {
    var _text$props$children, _text$props;

    const {
      stringValue,
      text
    } = getRawSlots(item === null || item === void 0 ? void 0 : item.content, ["text"]);
    return !isNil(text) ? (_text$props$children = (_text$props = text.props) === null || _text$props === void 0 ? void 0 : _text$props.children) !== null && _text$props$children !== void 0 ? _text$props$children : "" : stringValue !== null && stringValue !== void 0 ? stringValue : "";
  }

  return "";
}